import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
//
//
//
//
//
//

import Dropzone from "dropzone";
import { showToast } from "@Shared/utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DropzoneWrapper",
  props: {
    maxFiles: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      dropzone: {},
      VALID_DOCUMENTS_EXTENSIONS: ["pdf", "doc", "docx", "xls", "xlsx", "csv", "txt", "pptx", "ppt", "odp", "odt", "ods"],
      VALID_IMAGES_EXTENSIONS: ["jpg", "jpeg", "png", "tiff"],
      isDragging: false,
      timeout: 0
    };
  },
  computed: {
    IsDocumentDragOver() {
      return this.counter > 0;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.dropzone = new Dropzone(this.$refs.dropzone, {
        url: "/",
        maxFiles: this.maxFiles,
        thumbnailHeight: 300,
        thumbnailWidth: 300,
        autoProcessQueue: false,
        method: "put",
        maxFilesize: 25,
        clickable: false,
        sending: (file, xhr) => {
          //monkey patch for avoiding multipart/form-data
          const _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, file);
          };
        },
        acceptFiles: "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
        accept: (file, done) => {
          const extension = file.name.split(".").pop();
          if (this.isValidExtension(extension)) done();else done("File type not supported.");
        }
      });
      this.dropzone.on("addedfile", this.addedFile);
      this.dropzone.on("addedfiles", this.addedFiles);
      this.dropzone.on("dragleave", this.handleDragLeave);
      this.dropzone.on("dragover", this.handleDragOver);
    },
    isValidExtension(extension) {
      var _context, _context2;
      if (_includesInstanceProperty(_context = this.VALID_DOCUMENTS_EXTENSIONS).call(_context, extension.toLowerCase())) return "document";else if (_includesInstanceProperty(_context2 = this.VALID_IMAGES_EXTENSIONS).call(_context2, extension.toLowerCase())) return "image";else return false;
    },
    handleDragOver() {
      this.isDragging = true;
      clearTimeout(this.timeout);
      this.$emit("drag-enter");
    },
    handleDragLeave() {
      this.isDragging = false;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!this.isDragging) {
          this.$emit("drag-leave");
        }
      }, 100);
    },
    handleDragStart() {
      this.$emit("dragStart");
    },
    handleDragEnd() {
      this.$emit("dragEnd");
    },
    addedFile(file) {
      if (!this.addingFiles) {
        if (this.isValidExtension(file.name.split(".").pop())) this.$emit("added-file", [file]);else this.handleUnsupportedFile();
      }
    },
    addedFiles(filesAdded) {
      const files = _Array$from(filesAdded);
      if (files.every(file => this.isValidExtension(file.name.split(".").pop()))) this.$emit("added-files", files);else this.handleUnsupportedFile();
    },
    handleUnsupportedFile() {
      showToast("error", "fileTypeNotSupported");
      this.removeAllFiles();
    },
    removeAllFiles() {
      this.$emit("removed-all-files");
      this.dropzone.removeAllFiles();
    }
  }
});